import m from "mithril";
import _ from "underscore";
import $ from "jquery";
import noUiSlider = require('nouislider');
import reactive = require('../../model/reactive');
import {SliderItem} from "../../model/items/slider";
import {Vnode} from "mithril";

export class SliderView {
    public static component = {
        view: (vnode :Vnode) => {
            return m(SliderView, vnode.attrs);
        }
    };
    private cellItem: SliderItem;
    private noUiSlider?: noUiSlider.noUiSlider;

    constructor(attr: any) {
        this.cellItem = <SliderItem>attr.attrs.cellItem;

        // Update view on variable change
        if (this.cellItem.variable) {
            reactive.bind(() => {
                this.updateView();
            }, [this.cellItem.variable]);
        }

    }

    view(): any {

        const value = this.cellItem.getVariable();
		const questionary = this.cellItem.questionary;
		const labels = this.cellItem.labels;

        return m('div', {
                'class': "slider" + (this.isValueUndefined(value) ? " noValue" : "")
            }, [
                m('div.slider-value', {}, this.renderSliderValue() ),
                m('div', {
                    oncreate: (vnode) => {

                        noUiSlider.create(<HTMLElement>vnode.dom, {
							start: [this.cellItem.getVariable()],
							range: {
								'min': [this.cellItem.range.min],
								'max': [this.cellItem.range.max]
							},
							direction: $('html').attr('dir') || 'ltr',
							step: this.cellItem.range.step,
							connect: "lower",
						});
                        // @ts-ignore
                        this.noUiSlider = vnode.dom.noUiSlider;

                        this.noUiSlider!.on('change', v => {
							if (this.isValueUndefined(this.cellItem.getVariable())) {
								this.updateVariable(v[0]);
								// @ts-ignore
								this.noUiSlider.updateOptions({
									start: [this.cellItem.getVariable()],
								})
							} else {
								this.updateVariable(v[0]);
							}
						}); // is defined in vnode.dom
                        this.noUiSlider!.on('slide', v => this.updateVariable(v[0]));
                        if (vnode.state.disabled) {
                            // @ts-ignore
                            this.noUiSlider!.setAttribute('disabled', true);
                        }

                        this.updateView();
						this.setupInitialValue(<HTMLElement>vnode.dom);
                    },
                    onupdate: vnode => {
                        const noUiSliderElement = vnode.dom;
                        if (this.cellItem.cell.enabled) {
                            noUiSliderElement.removeAttribute('disabled');
                        } else {
                            noUiSliderElement.setAttribute('disabled', 'disabled');
                        }
                    }
                }),
                m('div.slider-labels'+this.getLabelsClass(), {}, [
                    m('.labelLeft', {}, labels.left ? m.trust(questionary.renderText(labels.left)) : null),
                    m('.labelCenter', {}, labels.center ? m.trust(questionary.renderText(labels.center)) : null),
                    m('.labelRight', {}, labels.right ? m.trust(questionary.renderText(labels.right)) : null),
                ]),
            ]
        );
    }

    private getLabelsClass(): string {
        const l = this.cellItem.labels;
        return '.labels-'+(l.left?'l':'')+(l.center?'c':'')+(l.right?'r':'');
    }

    private updateVariable(value: number) {
		this.cellItem.set(value);
        m.redraw();
    }

    private isValueUndefined(value: number) {
        return _.isUndefined(value) || value === null;
    }

    private renderSliderValue(): string {
        if (this.cellItem.getVariable() !== undefined && this.cellItem.getVariable() !== null) {
            return this.cellItem.getVariable() + this.cellItem.unit;
        }
        return '';
    }

    private updateView() {
        let value = this.cellItem.getVariable();
        if( this.noUiSlider ) {
            // null value stands for missing -> initialValue
            if( this.isValueUndefined(value) ) {
                value = this.cellItem.initialValue;

            }
            const viewValue = Math.floor(<number>this.noUiSlider.get());
            if( viewValue !== value ) {
                this.noUiSlider.set(value);
            }
        }
    }

	/**
	 * Force slider visual show initial value
	 */
	private setupInitialValue(sliderElement: HTMLElement): void {
		if (this.noUiSlider && this.isValueUndefined(this.cellItem.getVariable())) {
			const value = this.cellItem.initialValue;
			const scale = Math.max(Math.min((value-this.cellItem.range.min) / (this.cellItem.range.max-this.cellItem.range.min), 1), 0);
			const translate = scale * 1000 - 1000;
			$(sliderElement).find('.noUi-connect').css('transform', `translate(0%, 0px) scale(${scale}, 1)`);
			$(sliderElement).find('.noUi-origin').css('transform', `translate(${translate}%, 0px)`);
		}
	}
}

/* Umístění slideru před vybráním hodnoty na střed (pro slidery se sudým počtem bodů)
.slider.noValue .noUi-origin {
	transform: translate(-500%, 0px) !important;
}
.slider.noValue .noUi-connect {
	transform: translate(0%, 0px) scale(0.5, 1)!important;
}
*/